import React from "react";
import "../store-map.css";

export default function StoreMap() {
  return (
          <figure className="store-location-map">
            <iframe
              title="Map to Technogenious Solutions at 17 Molynes Road, Kingston"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3794.2616720991805!2d-76.8030725!3d18.0130558!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8edb3f31b994f623%3A0xe1994f9340adfdae!2sTechnogenious%20Solutions%20Ltd!5e0!3m2!1sen!2sjm!4v1792805034219!5m2!1sen!2sjm"
              width="600"
              height="360"
              loading="eager"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            />
            <figcaption>Shop 4B, 17 Molynes Road, Kingston 10, Jamaica</figcaption>
          </figure>
  );
}
